import styled from 'styled-components'
import { theme } from '../../../../../../style/theme'
import { colorTheme } from '../../../../../../style/theme/colorTheme'

export const PickupMonitorActionButtonWrap = styled.button`
	font-size: 1rem;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 5.63em;
	padding: 0.31em 0.63em;
	gap: 0.56em;
	border-radius: 0.75em;
	cursor: pointer;
	user-select: none;
	transition: all 0.2s ease-in-out;
	box-shadow: 0 4px 4px 0 ${colorTheme.pickupMonitor.actionButton.shadow};

	&:hover {
		box-shadow: 0px 10px 10px 0px ${colorTheme.pickupMonitor.actionButton.shadow};
	}

	&.unpaid {
		border: 2px solid ${colorTheme.pickupMonitor.actionButton.unpaid.border};
		background-color: ${colorTheme.pickupMonitor.actionButton.unpaid.background};
	}

	&.awaiting-pickup {
		border: 2px solid ${colorTheme.pickupMonitor.actionButton.awaitingPickup.border};
		background-color: ${colorTheme.pickupMonitor.actionButton.awaitingPickup.background};
	}

	&.processing-pickup {
		border: 2px solid ${colorTheme.pickupMonitor.actionButton.processingPickup.border};
		background-color: ${colorTheme.pickupMonitor.actionButton.processingPickup.background};
	}

	&.disabled {
		opacity: 0.5;
		border-color: ${colorTheme.pickupMonitor.actionButton.disabled};

		&.awaiting-pickup {
			background-color: ${colorTheme.pickupMonitor.actionButton.disabled};
		}

		&:hover {
			box-shadow: none;
		}
	}
`
PickupMonitorActionButtonWrap.displayName = 'PickupMonitorActionButtonWrap'

export const PickupMonitorActionButtonText = styled.div`
	font-family: ${theme.fontRobotoMedium};
	font-size: 1em;
	font-weight: 500;
	color: ${colorTheme.pickupMonitor.actionButton.text};

	&.processing-pickup {
		color: ${colorTheme.pickupMonitor.actionButton.processingPickup.text};
		order: 2;
	}
`
PickupMonitorActionButtonText.displayName = 'PickupMonitorActionButtonText'

export const PickupMonitorActionButtonIcon = styled.div`
	display: flex;
	align-items: center;

	> svg {
		width: 1.31em;
		height: 1.31em;
		flex-shrink: 0;
		fill: ${colorTheme.pickupMonitor.actionButton.icon};
	}

	&.awaiting-pickup {
		> svg {
			width: 1.56em;
			height: 1.13em;
		}
	}

	&.processing-pickup {
		> svg {
			width: 1.63em;
			height: 1.63em;
			fill: ${colorTheme.pickupMonitor.actionButton.processingPickup.icon};
		}
	}
`
PickupMonitorActionButtonIcon.displayName = 'PickupMonitorActionButtonIcon'
